import { DocumentRejectionReason } from "@/types";

/**
 * Reject reason codes and their reviewer-facing labels (#7441, artboard 1j).
 *
 * The CODE is what the API persists in `documents.rejection_reason` and what
 * the list filter matches on; the LABEL is what the reviewer picks and what the
 * post-reject banner shows. The server owns the same table
 * (`document.RejectionReasonCode` in coronis-apps) — keep the two in step.
 *
 * Order here is display order in the dialog.
 */
export const REJECTION_REASON_OPTIONS: ReadonlyArray<{ code: DocumentRejectionReason; label: string }> = [
  { code: DocumentRejectionReason.WRONG_FILE_OR_CLIENT, label: "Wrong file or client" },
  { code: DocumentRejectionReason.EXTRACTION_UNFIXABLE, label: "Extraction can't be fixed with mapping" },
  { code: DocumentRejectionReason.DUPLICATE, label: "Duplicate" },
  { code: DocumentRejectionReason.OTHER, label: "Other" },
];

/**
 * Label for a stored rejection_reason. Documents rejected before #7441 carry
 * free text here ("reason not provided", or whatever the caller typed), so an
 * unknown value is returned verbatim rather than hidden.
 */
export const rejectionReasonLabel = (reason: string | null | undefined): string | null => {
  if (!reason) return null;
  return REJECTION_REASON_OPTIONS.find((o) => o.code === reason)?.label ?? reason;
};
